export enum RADIO_BUTTON_SIZES {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
}

export enum RADIO_BUTTON_VARIANTS {
  PRIMARY = 'PRIMARY',
  NEUTRAL = 'NEUTRAL',
}
